import styled from 'styled-components';
import { IMG_GUIDE1, IMG_GUIDE2, IMG_GUIDE3, IMG_GUIDE4 } from '@repo/assets';

type Props = {
  textAlign: 'center' | 'left';
};

export const CashPickupGuideContent = ({ textAlign }: Props) => {
  return (
    <>
      <TitleWrapper textAlign={textAlign}>
        <Title>Guide for Cash Pick up</Title>
        <SubTitle>
          Cash Pick-up is a refund method
          <br />
          instead of remittance.
        </SubTitle>
      </TitleWrapper>
      <GuideWrapper>
        <GuideText textAlign={textAlign}>
          <GuideImg src={IMG_GUIDE1} alt='' />
          After you enter your information, the MTCN code will appear on the
          screen, which means you are ready to receive your refund
        </GuideText>
        <GuideText textAlign={textAlign}>
          <GuideImg src={IMG_GUIDE2} alt='' />
          Visit a Western Union agent location based on your passport nationality within 3 months of your departure.
          <br />
          Click{' '}
          <Link
            href='https://www.westernunion.com/global-services/find-locations?WUCountry=us&WULanguage=en'
            target='_blank'
          >
            here
          </Link>{' '}
          to find locations.
        </GuideText>
        <GuideText textAlign={textAlign}>
          <GuideImg src={IMG_GUIDE3} alt='' />
          Fill out an application with the information you received from the
          sender. (Please bring your government-issued ID)
        </GuideText>
        <GuideText textAlign={textAlign}>
          <GuideImg src={IMG_GUIDE4} alt='' />
          Submit the application and pick up cash at the agent locations.
        </GuideText>
      </GuideWrapper>
    </>
  );
};

export default CashPickupGuideContent;

const TitleWrapper = styled.div<{ textAlign: 'center' | 'left' }>`
  margin-bottom: 8px;
  text-align: ${({ textAlign }) => textAlign};
`;
const Title = styled.strong`
  display: block;
  margin-bottom: 4px;
  font-size: 22px;
  font-weight: 700;
  line-height: 150%;
`;

const SubTitle = styled.small`
  color: var(--KTP-Grayscale-Gray_07, #999);
  font-size: 14px;
  font-weight: 600;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
`;

const GuideWrapper = styled.ul`
  display: flex;
  margin-bottom: 16px;
  flex-direction: column;
  gap: 36px;
`;

const GuideImg = styled.img`
  width: 100%;
  margin-bottom: 8px;
`;

const GuideText = styled.li<{ textAlign: 'center' | 'left' }>`
  color: #80848a;
  text-align: ${({ textAlign }) => textAlign};
  font-size: 14px;
  line-height: 150%; /* 21px */
  font-weight: 500;
  letter-spacing: -0.28px;
`;

const Link = styled.a`
  color: #80848a;
  text-decoration: underline;
`;
